<script>
  import axios from "axios";
  import { link } from "svelte-spa-router";
  import Layout from "../../Layout/Layout.svelte";
  import MenuHeading from "../../shared/MenuHeading.svelte";
  import config from "../../stores/config";
  import Select from "svelte-select";
  import { Wave } from "svelte-loading-spinners";
  import * as ls from "local-storage";
  import loadData from "../../utils/loadData";

  let uploading = false;

  let genSKU = (name, size = 5) => {
    if (name) {
      let temp = name
        .replaceAll("  ", " ")
        .split(" ")
        .slice(0, size)
        .map((words) => words.slice(0, 3))
        .join("-")
        .replaceAll("--", "-")
        .replaceAll("--", "-")
        .toUpperCase();
      // temp = temp.slice(0, temp.length - 1);
      return temp;
    } else return "";
  };

  let name = null;
  let price = 0;
  let inventoryLevel = 1;
  let reorderLevel = 0;
  let SKU = null;

  // "timber, foam, board & pine"
  let lotNumber;
  let length;
  let width;
  let thickness;
  let bundlePrice;
  let plankNumber;

  // selections
  let supplier = null;
  let class_ = null;
  let sMaterialProvider = null;

  const handleClear = () => {
    inventoryLevel = 1;
    reorderLevel = 0;
    price = 0;
    length = null;
    width = null;
    thickness = null;
    SKU = null;
    plankNumber = null;
    // name = null;
    // supplier = null;
    // bundlePrice = null;
  };

  const handleSubmit = async (e) => {
    if (name) SKU = genSKU(name);
    if (1 > 2) alert("... missing!");
    else {
      uploading = true;

      if (sMaterialProvider?.value == "Customer") {
        price = 0;
        inventoryLevel = 1;
        reorderLevel = 0;
      }

      if (/timber|foam|board|pine/.test(class_?.value) == false) {
        lotNumber = "";
        length = 0;
        width = 0;
        thickness = 0;
        bundlePrice = 0;
      }

      let data = {
        price,
        inventoryLevel,
        reorderLevel,
        SKU,
        supplierID: supplier?.value,
        class_: class_.value,
        name,
        lotNumber,
        length,
        width,
        thickness,
        bundlePrice,
        totalMM: length * width * thickness,
        materialProvider: sMaterialProvider?.value || "",
        plankNumber,
      };

      axios
        .post(`${$config.backendURL}/items`, data, {
          headers: { authorization: ls.get("jwt") },
        })
        .then((res) => {
          console.log(res.data);
          uploading = false;
          alert(`☑ Added Successfully`);
          loadData();
          handleClear();
        })
        .catch((err) => {
          alert("There was a problem, Refresh the page and retry");
          console.log(err);
          uploading = false;
        });
    }
  };
</script>

<svelte:head>
  <title>Add Item to Stock — Supreme Upholstery System</title>
</svelte:head>

<Layout>
  <MenuHeading
    title="Add new item to Stock"
    description="Fill out the form below to enter the item details. All fields are REQUIRED."
  />

  <div class="flex justify-end mb-6">
    <a class="btn btn-primary-outline" use:link href="/products">
      <i class="fas fa-arrow-left mr-3" />
      Return to Stock
    </a>
  </div>

  <form
    on:submit|preventDefault={handleSubmit}
    class="grid grid-cols-1 gap-y-4 text-gray-500 pb-8"
  >
    <div class="grid grid-cols-2 gap-8">
      <div class="grid grid-cols-3 gap-2 items-center">
        <div>Choose Category :</div>
        <div class="col-span-2">
          <Select
            items={$config.itemC}
            on:select={(e) => (class_ = e.detail)}
          />
        </div>
      </div>
      <div class="grid grid-cols-3 gap-2 items-center">
        <div>Stock Item Name :</div>
        <input
          class="col-span-2 shadow-sm placeholder-gray-300"
          type="text"
          bind:value={name}
          placeholder="Stock Item Name"
        />
      </div>
    </div>

    {#if /timber|foam|board|pine/.test(class_?.value) == false}
      <div class="grid grid-cols-2 gap-8">
        {#if class_?.value == "fabric"}
          <div class="grid grid-cols-3 gap-2 items-center">
            <div>Material Provider :</div>
            <div class="col-span-2">
              <Select
                items={["Customer", "Supreme"]}
                on:select={(e) => (sMaterialProvider = e.detail)}
              />
            </div>
          </div>
        {/if}
        {#if sMaterialProvider?.value != "Customer"}
          <div class="grid grid-cols-3 gap-2 items-center">
            <div>Select the supplier :</div>
            <div class="col-span-2">
              <Select
                items={$config.suppliers}
                on:select={(e) => (supplier = e.detail)}
              />
            </div>
          </div>
        {/if}
      </div>
    {/if}

    <div
      class="grid grid-cols-2 gap-8"
      class:customer-fabric={sMaterialProvider?.value == "Customer"}
    >
      <div class="grid grid-cols-3 gap-2 items-center">
        <div>Quantity :</div>
        <input
          class="col-span-2 shadow-sm placeholder-gray-300"
          type="number"
          step="any"
          bind:value={inventoryLevel}
          placeholder="Quantity"
        />
      </div>
    </div>

    {#if /timber|foam|board|pine/.test(class_?.value) == false}
      <div
        class="grid grid-cols-2 gap-8"
        class:customer-fabric={sMaterialProvider?.value == "Customer"}
      >
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>EOQ :</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            type="number"
            step="any"
            bind:value={reorderLevel}
            placeholder="EOQ"
          />
        </div>
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>Unit Price :</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            bind:value={price}
            type="number"
            step="any"
            placeholder="Unit Price"
          />
        </div>
      </div>
    {/if}

    {#if /timber|foam|board|pine/.test(class_?.value)}
      <div class="grid grid-cols-2 gap-8">
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>Lot Number :</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            bind:value={lotNumber}
            type="text"
            placeholder="Lot Number"
          />
        </div>
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>Plank Number :</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            bind:value={plankNumber}
            type="text"
            placeholder="Plank Number"
          />
        </div>
      </div>

      <div class="grid grid-cols-2 gap-8">
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>Length :</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            type="number"
            step="any"
            bind:value={length}
            placeholder="Length"
          />
        </div>
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>Width :</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            bind:value={width}
            type="number"
            step="any"
            placeholder="Width"
          />
        </div>
      </div>

      <div class="grid grid-cols-2 gap-8">
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>Thickness :</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            type="number"
            step="any"
            bind:value={thickness}
            placeholder="Thickness"
          />
        </div>
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>Bundle Price :</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            bind:value={bundlePrice}
            type="number"
            step="any"
            placeholder="Bundle Price"
          />
        </div>
      </div>

      <div class="grid grid-cols-2 gap-8">
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>EOQ :</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            type="number"
            step="any"
            bind:value={reorderLevel}
            placeholder="EOQ"
          />
        </div>
      </div>
    {/if}

    {#if uploading}
      <div class="grid grid-cols-1 gap-8">
        <div class="flex items-center justify-center btn btn-primary-outline">
          <Wave size="25" color="rgb(244,162,97)" unit="px" />
          <span class="ml-4">Please wait...</span>
        </div>
      </div>
    {:else}
      <!-- else content here -->
      <div class="grid grid-cols-2 gap-8">
        <button class="btn btn-primary-outline" on:click={handleClear}>
          <i class="fas fa-times-circle mr-3" />
          Clear Form
        </button>
        <button class="btn btn-primary">
          <i class="fas fa-check-circle mr-3" />
          Save to Database
        </button>
      </div>
    {/if}
  </form>
</Layout>

<style>
  .customer-fabric {
    display: none;
  }
</style>
